import AbilityScoreBoxSvg from "./AbilityScoreBoxSvg";

export default AbilityScoreBoxSvg;
export { AbilityScoreBoxSvg };
